/**
 * minutesFilter
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

import { secondsToReadable } from '@shared/utils/datetime';

export function minutesFilter() {
    return value => {
        if (value) {
            return secondsToReadable(value * 60);
        }
    };
}
